<div class="max-w-[90vw] min-w-[45vw]">
    <form *ngIf="itemForm" [formGroup]="itemForm">
        
        <!-- Header -->
        <div class="flex flex-0 items-center justify-between h-16 pr-3 sm:pr-5 pl-6 sm:pl-8 bg-primary text-on-primary" style="margin: -24px;">
            <div class="text-lg font-medium">{{data.title}}</div>
            <button
                mat-icon-button
                type="button"
                (click)="dialogRef.close(false)"
                [tabIndex]="-1">
                <mat-icon
                    class="text-current"
                    [svgIcon]="'heroicons_outline:x-mark'"></mat-icon>
            </button>
        </div>

        <!-- Content -->
        <div class="grid grid-cols-2 gap-4 w-full mt-12 max-h-[calc(100vh-230px)] overflow-y-scroll px-1">

            <mat-form-field class="fuse-mat-dense" [subscriptSizing]="'dynamic'">
              <mat-label>Sequence</mat-label>
              <input
                matInput
                type="number"
                step="10"
                name="sequence"
                [formControlName]="'sequence'"
                placeholder="10"
              />
              <mat-hint>In 10's (e.g., 10, 20, 30)</mat-hint>
            </mat-form-field>

            <mat-form-field class="fuse-mat-dense" [subscriptSizing]="'fixed'">
              <mat-label>Op Code</mat-label>
              <input
                matInput
                [formControlName]="'operationCode'"
                [matAutocomplete]="auto"
                (input)="filterOpCodes($event)">
              <mat-autocomplete #auto="matAutocomplete" (optionSelected)="selectOpCode($event)">
                <mat-option *ngFor="let op of filteredOpCodes" [value]="op.code">
                  {{ op.code }} - {{ op.name }}
                </mat-option>
              </mat-autocomplete>
            </mat-form-field>

            <mat-form-field class="col-span-2 fuse-mat-dense" [subscriptSizing]="'dynamic'">
              <mat-label>Operation Name</mat-label>
              <input
                matInput
                name="operationName"
                [formControlName]="'operationName'"
                placeholder="Enter operation name"
              />
            </mat-form-field>

            <mat-form-field class="fuse-mat-dense" [subscriptSizing]="'dynamic'">
              <mat-label>Cost Center</mat-label>
              <mat-select [formControlName]="'costCentreCode'" (selectionChange)="costCentreChanged($event)">
                <mat-option *ngFor="let cc of costCentres" [value]="cc.code">
                  {{ cc.code }} - {{ cc.name }}
                </mat-option>
              </mat-select>
            </mat-form-field>

            <div class="flex items-center">
              <mat-checkbox [formControlName]="'isSubcontracted'">
                Subcontracted
              </mat-checkbox>
            </div>
              
            <mat-form-field *ngIf="!itemForm.controls['isSubcontracted'].value" class="fuse-mat-dense" [subscriptSizing]="'dynamic'">
              <mat-label>Cost Center Hourly Rate</mat-label>
              <input
                matInput
                type="number"
                step="0.01"
                min="0"
                name="costCentreRate"
                [formControlName]="'costCentreRate'"
                placeholder="0.00"
              />
              <span matTextPrefix>£&nbsp;</span>
              <mat-hint>Override rate for this cost center (default: 0.00)</mat-hint>
            </mat-form-field>

            <mat-form-field *ngIf="itemForm.controls['isSubcontracted'].value" class="fuse-mat-dense" [subscriptSizing]="'dynamic'">
              <mat-label>Subcontractor Name</mat-label>
              <input
                matInput
                name="subcontractorName"
                [formControlName]="'subcontractorName'"
                placeholder="Enter subcontractor name"
              />
            </mat-form-field>

            <mat-form-field *ngIf="itemForm.controls['isSubcontracted'].value" class="fuse-mat-dense" [subscriptSizing]="'dynamic'">
              <mat-label>Cost</mat-label>
              <input
                matInput
                type="number"
                step="0.01"
                min="0"
                name="subcontractorHourlyRate"
                [formControlName]="'subcontractorHourlyRate'"
                placeholder="0.00"
              />
              <span matTextPrefix>£&nbsp;</span>
            </mat-form-field>

            <mat-form-field class="fuse-mat-dense" [subscriptSizing]="itemForm.controls['isSubcontracted'].value ? 'dynamic' : 'fixed'">
              <mat-label>{{!itemForm.controls['isSubcontracted'].value ? 'Setup Time (hrs)' : 'Lead Time (weeks)'}}</mat-label>
              <input
                matInput
                type="number"
                step="0.5"
                min="0"
                name="setupHours"
                [formControlName]="'setupHours'"
                placeholder="0.5"
              />
            </mat-form-field>

            <mat-form-field *ngIf="!itemForm.controls['isSubcontracted'].value" class="fuse-mat-dense" [subscriptSizing]="'dynamic'">
              <mat-label>Run Time/Unit (hrs)</mat-label>
              <input
                matInput
                type="number"
                step="0.1"
                min="0"
                name="runPerUnitHours"
                [formControlName]="'runPerUnitHours'"
                placeholder="0.25"
              />
            </mat-form-field>

            <mat-form-field class="col-span-2 fuse-mat-dense" [subscriptSizing]="'dynamic'">
              <mat-label>Optional Notes</mat-label>
              <textarea
                matInput
                name="notes"
                rows="3"
                [formControlName]="'notes'"
                placeholder="Enter any additional notes"
              ></textarea>
            </mat-form-field>

            <!-- Actions -->
            <!-- <div class="flex flex-row mt-8 gap-4 dialog-button-row">
                <button
                  mat-stroked-button
                  color="accent"
                  type="button"
                  (click)="dialogRef.close(false)"
                >
                  Cancel
                </button>
                <button mat-flat-button color="primary" [disabled]="itemForm.invalid">
                  Add Step
                </button>
              </div> -->
            
        </div>

        <!-- Divider -->
        <div class="my-6 border-t"></div>

        <!-- Actions -->
        <div class="flex flex-row items-between w-full gap-4">
            <div class="flex items-center justify-end ml-auto gap-4">
                <button
                    (click)="dialogRef.close(false)"
                    mat-stroked-button
                    type="button">
                    Cancel
                </button>

                <button
                    (click)="submit()"
                    mat-flat-button
                    type="button"
                    [color]="'primary'"
                    [disabled]="itemForm.invalid">
                    Add Step
                    <!-- <mat-icon class="icon-size-4 mr-1" svgIcon="feather:check-circle"></mat-icon>
                    <span class="ml-1">Add Step</span> -->
                </button>
            </div>
        </div>
    </form>
</div>
